import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stockTransferStatus'
})
export class StockTransferStatusPipe implements PipeTransform {

  transform(value: Number) {
    let status = ''
    switch(value) {
      case 0:
        status = 'In Transit';
        break;
      case 1:
        status = 'Returned';
        break;
      case 2:
        status = 'Closed';
        break;
      case 3:
        status = 'Cancelled';
        break;
      default:
        status = 'In Transit';
        break;
    }
    return status;
  }

}
